// ? open to other names for this file (didn't want to call it '/product' & we already have '/cart')

import { InitialUrlSearchParams, SiteSettings } from './environment';
import { IS_NATIVE_APP_CLIENT } from './helpers';

export const lowerCasedBlacklistedOptionValues = ['defaulttitle', 'onesize', 'nocolor', 'undefined'];

export const MOBILE_BREAKPOINT = 768;

export const MUI_MOBILE_BREAKPOINT = '(max-width: 767.98px)';
export const MUI_TABLET_BREAKPOINT = '(min-width: 768px) and (max-width: 1059.98px)'; // ? [REVISIT] Navigation specific???
export const MUI_DESKTOP_BREAKPOINT = '(min-width: 1060px)'; // ? [REVISIT] Navigation specific???

export const ALO_MOVES_30_GWP = 'ALOMOVES30GWP';

export const ALO_MOVES_REAL_SKU = 'ALOMOVES1YRNEW';

export const E_GIFT_CARD_SKU = 'GCSHOPIFY';

export const PRODUCT_TILE_FALLBACK_IMG =
  'https://cdn.shopify.com/s/files/1/2185/2813/files/product-tile-fallback_320x.jpg?v=1';

export const EARLY_ACCESS_TAG = 'Policy:EarlyAccess';
export const EARLY_ACCESS_TAGS = [EARLY_ACCESS_TAG, 'b:1:Early Access'];
// ? [REVISIT] required until we stop fetching collection metadata via SSR variable vs 'fetch'
export const EARLY_ACCESS_COLLECTION_HANDLE = 'vip-early-access';
export const EARLY_ACCESS_MENS_COLLECTION_HANDLE = 'mens-early-access';

export const E_GIFT_CARD_PRODUCT_TYPE = 'e gift card'; // can't use handle anymore with the addition of e-gift card swatches

export const COMING_SOON_TAG = 'Inventory:Coming Soon';
export const INTERNATIONAL_RESTRICTIONS_TAG = 'Policy:InternationalRestrictions';
export const BADGE_ORDER = {
  AdvanceOrder: 1,
  'b:3:New': 2,
  'b:4:New Colors': 3,
  'b:1:Embody Collection': 4,
};
export const HIDDEN_INVENTORY_TAG = 'Inventory:Hidden';
export const DISABLE_SOLD_OUT_MESSAGING_TAG = 'Disable:SoldOutMessaging';
export const ONLINE_SALES_PRICE_TAG = 'OnlineSalePrice';
export const PREORDER_TAG = 'Preorder';
export const ADVANCE_ORDER_TAG = 'AdvanceOrder';
export const ADVANCE_ORDER_BADGE_TEXT = 'Preorder';
export const SUPPRESS_MODEL_INFO_TAG = 'SuppressModelInfo';
export const SUPPRESS_BADGE_BELOW_SWATCH = 'SuppressBadgeBelowSwatch';

export const FIS_EXCLUDE_TAG = 'FIS-exclude';
export const BOPIS_EXCLUDE_TAG = 'BOPIS-exclude';
export const BOPIS_LAT_LONG = 'bopis_lat_long';
export const BOPIS_POSTAL_CODE = 'bopis_postal_code';

export const EXCHANGE_ONLY_TAG = 'Policy:ExchangeOnly';
export const SALE_EXCLUSION_TAG = 'Policy:SaleExclusion';
export const FINAL_SALE_TAG = 'Policy:FinalSale';

export const CANNOT_SHIP_OUTSIDE_US_TAG = 'Policy:CannotShipOutsideUS';
export const BEAUTY_SHIPPING_RESTRICTIONS_TAG = 'Policy:BeautyShippingRestrictions';
export const CANNOT_SHIP_TO_EEA_TAG = 'Policy:CannotShipToEEA';

export const removeGWP = 'hasRemovedGWP';
export const removeBeautyGift = 'hasRemovedBeautyGift';
export const removeAloMovesGift = 'hasRemovedAloMoves';

//@ts-expect-error
export const globalWindow: Window & Record<string, unknown> = window;

export const COUNTRIES_WITH_FORCED_REDIRECT = window.getCountriesWithForcedRedirect
  ? window?.getCountriesWithForcedRedirect()
  : null;
export const MAX_NAME_LENGTH = 50;
export const NAVBAR_ELEMENT = '#shopify-section-main-nav';

export const IS_PRESUMABLY_EXISTING_CUSTOMER = !!window.localStorage.getItem('didUserLogInPreviously');
export const IS_USER_JUST_AUTHORIZED = InitialUrlSearchParams.get('auth_success') === '1';
export const ALO_API_HOST = `https://${
  window.location.hostname.includes('myshopify.com')
    ? process.env['REACT_APP_ALO_API_HOST']
    : 'api.' + window.location.hostname.replace('www.', '')
}/alo-api`;

export const IS_CHECKOUT_PAGE = !!window.Shopify.Checkout;
export const SHOP_LOCALE = window.Shopify.locale;
export const ALO_OMS_HOST = `https://${process.env['REACT_APP_ALO_OMS_HOST']}`;
export const EXCLUSION_TAG = 'excludeExchange';
export const IS_APP_ONLY_SALE_ENABLED = SiteSettings?.appOnlySale?.enabled && !IS_NATIVE_APP_CLIENT;
export const LUXURY_HANDBAG_TAG = 'BagCollection-Family';
